import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/sequence-modal/sequence-modal.js';
      import {ObcSequenceModalType} from '@oicl/openbridge-webcomponents/dist/components/sequence-modal/sequence-modal.js';
import {SequenceValue} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';

      export interface Props {
     type?: ObcSequenceModalType;
     stepLabel?: string;
     stepValue?: SequenceValue;
     modalTitle?: string;
     subtitle?: string;
     hasTimeStamp?: boolean;
     timeValue?: string;
     timeLabel?: string;
     hasActions?: boolean;
     closeLabel?: string
   }

      
  
      export type {ObcSequenceModalType} from '@oicl/openbridge-webcomponents/dist/components/sequence-modal/sequence-modal.js';
export type {SequenceValue} from '@oicl/openbridge-webcomponents/dist/components/sequence-step/sequence-step.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSequenceModal',
  props: {
    type: {},
    stepLabel: {},
    stepValue: {},
    modalTitle: {},
    subtitle: {},
    hasTimeStamp: { type: Boolean },
    timeValue: {},
    timeLabel: {},
    hasActions: { type: Boolean },
    closeLabel: {}
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-sequence-modal',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})